type Props = {
  visible: boolean
  checked: boolean
  disabled: boolean
  onChange: (checked: boolean) => void
}

/** Display-only. Hidden unless the signed-in user is in ADMIN_EMAILS. */
export default function TestProjectFlagRow({ visible, checked, disabled, onChange }: Props) {
  if (!visible) return null
  return (
    <label
      style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, marginTop: 10, color: 'var(--ink3)' }}
      data-testid="project-test-flag-row"
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        data-testid="project-test-flag"
        onChange={(e) => onChange(e.target.checked)}
      />
      Test project — hidden from billing sync to Bookeeping.ai
    </label>
  )
}
